import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';

import { GuestReportPage } from './pages';

export const GuestReportRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={`${match.path}/:propertyId/:userId/:reservationId`} component={GuestReportPage} />
  </Switch>
);
